export default __webpack_public_path__ + "static/media/renameIcon.6a81cc6a.svg";